module.exports = __webpack_public_path__ + "static/media/logo-hex.33e0830c.png";